import * as React from "react"
import type { SVGProps } from "react"
const SvgRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m13.18 12.15-3.9 3.9a1 1 0 0 0-.28.7q0 .43.28.7a1 1 0 0 0 .7.28 1 1 0 0 0 .7-.28l4.6-4.6q.15-.15.22-.33a1 1 0 0 0 0-.75 1 1 0 0 0-.22-.32l-4.6-4.6a1 1 0 0 0-.7-.28 1 1 0 0 0-.7.27 1 1 0 0 0-.28.7q0 .43.27.7z" />
  </svg>
)
export default SvgRight
